export default () => ({
  loading: true,
  order: undefined,
  orderShippingStatus: '',
})
